module.exports = __webpack_public_path__ + "img/50.6e498130.png";